/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

import { BrandHeading, StatusPanel, type StatusPanelProps } from '@af/design-system-docs-ui';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';

import { PageContentContainer } from '../../../components/page-content-container';
import ThemedImg from '../../../components/themed-img';

type HeroProps = {
	headline: string;
	description?: string;
	status?: StatusPanelProps;
	className?: string;
	imageSrc?: {
		light: string;
		dark: string;
	};
};

const rootStyles = xcss({
	width: '100%',
	backgroundColor: 'color.background.neutral',
	paddingBlock: 'space.1000',
});

const Hero = ({ headline, description, status, imageSrc }: HeroProps) => {
	return (
		<Box xcss={rootStyles}>
			<PageContentContainer>
				<Inline alignInline="start" spread="space-between">
					<Stack space="space.300">
						<Stack space="space.100">
							<BrandHeading size="xlarge" as="h1">
								{headline}
							</BrandHeading>
							<Text size="large">{description}</Text>
						</Stack>

						{status && (
							<StatusPanel
								type={status.type}
								description={status.description}
								testId={status.testId}
								actions={status.actions}
							/>
						)}
					</Stack>
					{imageSrc && <ThemedImg src={imageSrc} alt={`Banner for ${headline} page`} />}
				</Inline>
			</PageContentContainer>
		</Box>
	);
};

export default Hero;
